export function initContentNavigationSnap() {
    const links = document.querySelectorAll('.blueprintContentNavigation__link');

    links.forEach(item => {
        item.addEventListener('click', e => snapToCenter(e.target));
    });

    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const el = mutation.target;
                if (el.classList.contains('is-active')) {
                    snapToCenter(el);
                }
            }
        }
    });

    links.forEach(item => {
        observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    function snapToCenter(item) {
        if (window.innerWidth >= 1000) return;

        const nav = item.closest('.blueprintContentNavigation');
        if (!nav) return;

        const navCenter = nav.offsetWidth / 2;
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;

        nav.scrollTo({
            left: itemCenter - navCenter,
            behavior: 'smooth'
        });
    }
}

export function initContentNavigationHeaderSwitch() {
    const contentNavigation = document.querySelector('div:has(>.blueprintContentNavigation)');
    const header = document.querySelector('header');

    if (contentNavigation && header) {
        const sentinel = document.createElement('div');
        contentNavigation.parentElement.insertBefore(sentinel, contentNavigation);

        function getRootMargin() {
            const w = window.innerWidth;

            if (w < 768) return '-55px 0px 0px 0px';
            if (w < 1250) return '-65px 0px 0px 0px';
            if (w < 1800) return '-70px 0px 0px 0px';
            return '-80px 0px 0px 0px';
        }

        const observer = new IntersectionObserver(([entry]) => {
            header.classList.toggle('is-sticky', !entry.isIntersecting);
        }, {
            rootMargin: getRootMargin(),
            threshold: 0
        });

        observer.observe(sentinel);
    }
}

export function initContentNavigationIdObserver() {
    const navLinks = document.querySelectorAll('.blueprintContentNavigation a');
    const header = document.querySelector('#header');
    const stickyNav = document.querySelector('.blueprintContentNavigation');

    if (navLinks.length) {
        const targets = [];

        navLinks.forEach(link => {
            const id = link.getAttribute('href').replace('#', '');
            const target = document.getElementById(id);
            if (target) targets.push({ link, target });
        });

        function getManualOffset() {
            const w = window.innerWidth;
            if (w < 768) return 20;
            if (w < 1250) return 30;
            return 40;
        }

        function getOffset() {
            const headerHeight = header ? header.offsetHeight : 0;
            const navHeight = stickyNav ? stickyNav.offsetHeight : 0;
            return headerHeight + navHeight + getManualOffset();
        }

        function onScroll() {
            const offset = getOffset();
            let activeIndex = -1;

            targets.forEach(({ target }, index) => {
                const rect = target.getBoundingClientRect();
                if (rect.top <= offset) {
                    activeIndex = index;
                }
            });

            navLinks.forEach(l => l.classList.remove('is-active'));
            if (activeIndex >= 0) {
                targets[activeIndex].link.classList.add('is-active');
            }
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    document.addEventListener('click', function(e) {
        const jumpmark = e.target.closest('a[href^="#"]');
        if (!jumpmark || jumpmark.closest('.modal')) return;
        const href = jumpmark.getAttribute('href');
        if (!href || href === '#') return;
        const target = document.getElementById(href.replace('#', ''));

        function getManualOffset() {
            const w = window.innerWidth;
            if (w < 768) return 18;
            if (w < 1250) return 28;
            return 38;
        }

        if (target) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const currentHeaderHeight = header ? header.offsetHeight : 0;
            const currentNavHeight = stickyNav ? stickyNav.offsetHeight : 0;
            window.scrollTo({
                top: window.scrollY + target.getBoundingClientRect().top - (currentHeaderHeight + currentNavHeight + getManualOffset()),
                behavior: 'smooth'
            });
        }
    }, true);
}